export enum PreviewState {
  Other = 'other',
  Success = 'success',
}

export enum CollectionType {
  FOLDER,
  FILES,
}
